export default function() {
    if(document.body.classList.contains("has-edit-mode-menu")) {
        console.debug("Do not convert in edit mode.")
        return;
    }

    const collapsibleElement = document.querySelector("div[id*='fragment'] .akkordeon ul.collapsible");
    if(!collapsibleElement) {
        return;
    }

    const firstDiv = collapsibleElement.querySelector("div:first-child");
    if(!firstDiv) {
        return;
    }

    const collapsibleListElements = collapsibleElement.querySelectorAll("li");
    if(collapsibleListElements) {
        firstDiv.replaceWith(...collapsibleListElements);
    }
}
